import { render, staticRenderFns } from "./fileMetaModal.vue?vue&type=template&id=489cbda1&scoped=true&"
import script from "./fileMetaModal.vue?vue&type=script&lang=js&"
export * from "./fileMetaModal.vue?vue&type=script&lang=js&"
import style0 from "./fileMetaModal.vue?vue&type=style&index=0&id=489cbda1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489cbda1",
  null
  
)

export default component.exports